var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgKp = function SvgKp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M5.077.1h682.53V512H5.077z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-4.761 -.094) scale(.93768)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.014,
    fill: "#fff",
    d: "M775.94 511.52H-75.92V.57h851.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M775.94 419.07H-75.92v92.457h851.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c60000",
    d: "M775.94 397.65H-75.92V114.44h851.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M775.94.576H-75.92v92.457h851.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.518 256.07c0 63.45-53.108 114.886-118.619 114.886-65.512 0-118.618-51.437-118.618-114.886 0-63.45 53.108-114.885 118.618-114.885 65.512 0 118.619 51.436 118.619 114.885z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c40000",
    d: "M175.83 270.567l-57.06-40.618 71.056-.289 22.636-66.367 21.164 66.147 71.057-.407-57.978 41.177 21.275 66.117-56.998-40.696-57.908 41.264z"
  }))));
};
export default __webpack_public_path__ + "assets/373fc27c96cc64f0e0782ac222635891.svg";
export { SvgKp as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/kp.svg